import $ from 'jquery'

// JavaScript for making sliders more mobile friendly. Uugh.
$(document).ready(function() {
    'use strict'

    const $overview = $('#overview');
    $overview.on('click', '[data-option]', function() {
        $overview.find('[data-option]').toggleClass('d-none');
        $overview.find('[data-for]').toggleClass('d-none');
    });

    const $sliders = $('.slider');
    let $currentSlider;

    $sliders.each(function() {
        $currentSlider = $(this)

        // make sure container keeps it's height
        setItemHeights();

        const items = $currentSlider.find('.slider--items .slider--item');

        items.each(function(i, item) {
            item.setAttribute('data-item-id', i);

            if (i === 0) {
                $currentSlider.find('.slider--navigation').append('<li class="slider--navigation-current" data-item-id="' + i + '"></li>');
            } else {
                $currentSlider.find('.slider--navigation').append('<li data-item-id="' + i + '"></li>');
            }
        });

        $currentSlider.find('.slider--items .slider--item').each(function() {
            $currentSlider.find('')
        });

        $(this).find('.slider--handler-prev').click(loadPrev);
        $(this).find('.slider--handler-next').click(loadNext);

        $(this).find('.slider--navigation li').click(function() {
            $currentSlider = $(this).parents('.slider');

            const itemId = $(this).attr('data-item-id');

            transition($currentSlider.find('.slider--item[data-item-id="' + itemId + '"]'));
        });
    });

    $(document).on('resize', function() {
        $sliders.each(function() {
            setItemHeights();
        });
    });

    function loadNext() {
        $currentSlider = $(this).parents('.slider');

        const $currentItem = $currentSlider.find('.slider--item:visible');
        let $nextItem = $currentItem.next('.slider--item');

        // restart at end
        if ($nextItem.length === 0) {
            $nextItem = $currentSlider.find('.slider--item').first();
        }

        transition($nextItem);
    }

    function loadPrev() {
        $currentSlider = $(this).parents('.slider');

        const $currentItem = $currentSlider.find('.slider--item:visible');
        let $prevItem = $currentItem.prev('.slider--item');

        // restart at end
        if ($prevItem.length === 0) {
            $prevItem = $currentSlider.find('.slider--item').last();
        }

        transition($prevItem);
    }

    function transition($newItem) {
        $currentSlider.find('.slider--item:visible').fadeOut(250, function() {
            $currentSlider.find('.slider--navigation li').removeClass('slider--navigation-current');
            $currentSlider.find('.slider--navigation li[data-item-id="' + $newItem.attr('data-item-id') + '"]')
                .addClass('slider--navigation-current');

            $newItem.fadeIn(250);
        });
    }

    function setItemHeights() {
        $currentSlider.find('.slider--item').each(function() {
            const $sliderContainer = $currentSlider.find('.slider--container');

            if (parseFloat($sliderContainer.css('min-height')) > $(this).height()) {
                $(this).css('min-height', $sliderContainer.css('min-height'));
            }
        });
    }

});
